import React, { useState, useCallback } from "react";
import Swal from "sweetalert2";
import DashboardWrapper from "../../components/DashboardWrapper";
import authService from "../../services/authService";
import { useNavigate } from "react-router-dom";


export default function ChangePassword() {
    const navigate = useNavigate();
  
  const [formData, setFormData] = useState({
    current_password: "",
    new_password: "",
    confirm_password: "",
  });

  const [loading, setLoading] = useState(false);

  const showSwal = useCallback((title, text, icon) => {
    Swal.fire({
      title,
      text,
      icon,
      confirmButtonText: "OK",
      customClass: { confirmButton: "btn btn-primary" },
      buttonsStyling: false,
    });
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.new_password !== formData.confirm_password) {
      showSwal("Validation", "Passwords do not match.", "warning");
      return;
    }

    const payload = {
      current_password: formData.current_password,
      new_password: formData.new_password,
      new_password_confirmation: formData.confirm_password,
    };

    setLoading(true);
    try {
      await authService.changePassword(payload);

      showSwal("Success", "Password changed successfully.", "success");

      setFormData({
        current_password: "",
        new_password: "",
        confirm_password: "",
      });
    } catch (error) {
      console.error(error.response?.data);
      showSwal(
        "Error",
        error.response?.data?.message ||
        JSON.stringify(error.response?.data?.errors) ||
        "Failed to change password.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const [showPassword, setShowPassword] = useState({
    current: false,
    new: false,
    confirm: false,
  });

  const togglePassword = (field) => {
    setShowPassword((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };



  return (
    <DashboardWrapper>
      <div className="container-fluid mt-4">
         <div className="d-flex justify-content-between align-items-center mb-4">
          <button
            className="btn btn-secondary d-flex align-items-center"
            onClick={() => navigate(-1)}
          >

            <span>Back</span>
          </button>
         
        </div>
        <div className="card shadow col-12">
          <div className="card-header">
            <h4 className="mb-0">Change Password</h4>
          </div>

          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-12 mb-3">
                  <label className="form-label">Current Password</label>
                  <div className="input-group">
                    <input
                      type={showPassword.current ? "text" : "password"}
                      name="current_password"
                      className="form-control"
                      value={formData.current_password}
                      onChange={handleChange}
                      required
                    />
                    <span
                      className="input-group-text cursor-pointer"
                      onClick={() => togglePassword("current")}
                    >
                      <i className={`bx ${showPassword.current ? "bx-show" : "bx-hide"}`} />
                    </span>
                  </div>
                </div>


                <div className="col-12 mb-3">
                  <label className="form-label">New Password</label>
                  <div className="input-group">
                    <input
                      type={showPassword.new ? "text" : "password"}
                      name="new_password"
                      className="form-control"
                      value={formData.new_password}
                      onChange={handleChange}
                      required
                    />
                    <span
                      className="input-group-text cursor-pointer"
                      onClick={() => togglePassword("new")}
                    >
                      <i className={`bx ${showPassword.new ? "bx-show" : "bx-hide"}`} />
                    </span>
                  </div>
                </div>


                <div className="col-12 mb-3">
                  <label className="form-label">Confirm New Password</label>
                  <div className="input-group">
                    <input
                      type={showPassword.confirm ? "text" : "password"}
                      name="confirm_password"
                      className="form-control"
                      value={formData.confirm_password}
                      onChange={handleChange}
                      required
                    />
                    <span
                      className="input-group-text cursor-pointer"
                      onClick={() => togglePassword("confirm")}
                    >
                      <i className={`bx ${showPassword.confirm ? "bx-show" : "bx-hide"}`} />
                    </span>
                  </div>
                </div>

              </div>

              <div className="mt-3">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" />
                      Changing...
                    </>
                  ) : (
                    "Change Password"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </DashboardWrapper>
  );
}
